import React from "react"
import MessageScreen from "./MessageScreen"

const WrongAccountScreen = () => (
  <MessageScreen title="This invite is for a different account.">
    If you believe this is a mistake, please contact your event organizer — they can
    resend the invite to the correct email address.
  </MessageScreen>
)

export default WrongAccountScreen
